export default __webpack_public_path__ + "static/media/elle10.82fccb2a.webp";